<template>
  <div>
    <div class="over-lay" @click="closePopup()"></div>
    <div class="popup">
      <span class="close-hldr" @click="closePopup()">
        <i class="material-icons">close</i>
      </span>
      <Error-Icon />
      <div class="hdr">Credit Limit Reached</div>
      <div class="content">
        You have reached a maximum limit of credits allotted to you. Please
        contact your administrator for more credits.
      </div>
      <div class="btn-section d-flex">
        <V-Button
          :className="'okBtn'"
          :text="'OK'"
          :callback="closePopup"
        ></V-Button>
      </div>
    </div>
  </div>
</template>

<script>
import button from '@/components/Button'
import ErrorIcon from '@/assets/icons/svg/errorTriangle.svg'
import sharedFunction from '@/assets/util/functions.js'
import { MxEvent } from '@/assets/util/constants/analytics.js'

export default {
  name: 'credit-limit-popup',
  components: {
    'V-Button': button,
    'Error-Icon': ErrorIcon,
  },
  methods: {
    closePopup() {
      sharedFunction.track(MxEvent.payWallClosed, null, this.$store.state)
      this.$emit('clickedOutside', true)
    },
    closeThankPopup() {
      sharedFunction.track(MxEvent.followLinkedinClose, null, this.$store.state)
      this.$emit('clickedOutside', true)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.p-t-25 {
  padding-top: 20px !important;
}
%svg-img {
  width: 60px !important;
  height: 60px !important;
}
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 85%;
  color: #474542;
  top: 50%;
  padding: 30px 16px 0px 16px;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  border-radius: 6px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: initial;
  .close-hldr {
    position: absolute;
    right: 12px;
    top: 12px;
    display: flex;
    i {
      font-size: 15px;
      cursor: pointer;
      color: #787878;
    }
  }
  .hdr {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    line-height: 1.35;
    margin-top: 15px;
  }
  .content {
    line-height: 1.4;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .btn-section::v-deep {
    button {
      cursor: pointer;
      width: 100px;
      height: 34px;
    }
    margin-bottom: 30px;
  }
}
</style>
